module.exports = {
      id: "9fbbe5198ed2570dbe3bf6f0c37f3d5aconstruction-panel.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#9fbbe5198ed2570dbe3bf6f0c37f3d5aconstruction-panel.svg",
      toString: function () {
        return this.url;
      }
    }